import React from 'react'
import { useSelector } from 'react-redux'
import { TableCell, TableRow } from '@mui/material'
import { Link } from 'react-router-dom'

import { PROFILE_PAGE } from 'utils/paths'
import { getPipelines } from 'store/actions/pipeline'
import {
  getDeadlineState,
  getNextDeadlineDate,
  getNextDeadlinesFromPrograms
} from '../Deadlines/helpers'
import PipelineStageButton from 'components/PipelineStageButton'
import CardActions from 'components/CardActions'
import ResetCardAction from 'components/CardActions/actions/ResetAction'
import ArchiveCardAction from 'components/CardActions/actions/ArchiveAction'
import HideCardAction from 'components/CardActions/actions/HideAction'
import { formatNumber, formatSINumber } from 'utils/helpers'
import Deadline from 'components/Deadlines'
import { selectIsLibraryMode } from 'store/selectors/user'

const CollapsedCard = ({
  id,
  name,
  medianGiftSize,
  deadlineDates,
  annualRevenue,
  opportunity,
  funderPrograms
}) => {
  const showResetCardAction =
    opportunity && (opportunity.pipelineStage || opportunity.archived || opportunity.hidden)

  const showArchiveCardAction =
    opportunity && opportunity.pipelineStage && !opportunity.hidden && !opportunity.archived

  const showHideCardAction = !opportunity || !opportunity.hidden

  const { hasOngoingDeadline } = getNextDeadlinesFromPrograms(funderPrograms)
  const deadlineDate = getNextDeadlineDate(deadlineDates)
  const { color: cardColor, label } = getDeadlineState({
    deadlineDate,
    isOngoing: hasOngoingDeadline
  })

  const formattedGiftSize =
    medianGiftSize !== null ? formatNumber(Math.round(medianGiftSize)) : 'N/A'
  const formattedRevenue = annualRevenue !== null ? formatSINumber(annualRevenue) : 'N/A'

  const isLibraryMode = useSelector(selectIsLibraryMode)

  return (
    <TableRow key={id} className={cardColor}>
      <TableCell>
        <Link to={`${PROFILE_PAGE}/${id}`}>{name}</Link>
      </TableCell>
      <TableCell>{formattedGiftSize}</TableCell>
      <TableCell>
        {deadlineDate ? <Deadline date={deadlineDate} format="short" /> : label}
      </TableCell>
      <TableCell>{formattedRevenue}</TableCell>
      {!isLibraryMode && (
        <TableCell className="pipeline-stage">
          <PipelineStageButton
            buttonClass="Material-cards__expanded-state"
            opportunity={opportunity}
            funderId={id}
            loadData={() => getPipelines(false)}
          />
        </TableCell>
      )}
      <TableCell>
        <CardActions
          funder={{ id }}
          opportunityId={opportunity && opportunity.id}
          actions={[
            showResetCardAction && ResetCardAction,
            showArchiveCardAction && ArchiveCardAction,
            showHideCardAction && HideCardAction
          ]}
          loadData={() => getPipelines(false)}
        />
      </TableCell>
    </TableRow>
  )
}

export default CollapsedCard
